module.exports = __webpack_public_path__ + "static/media/key-challanges-bg.3049bf44.svg";